<template>
  <!-- 扣分登记 -->
  <div class="deduction-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-select v-model="searchInfo.employeeId" placeholder="全部员工" clearable filterable @change="resetSearch">
            <template #prefix>员工</template>
            <el-option v-for="e in staffOptions" :key="e.employeeId" :label="staffLabel(e)" :value="e.employeeId"/>
          </el-select>
          <el-date-picker v-model="searchInfo.month" type="month" value-format="YYYY-MM" placeholder="扣分月份" clearable style="width: 150px"/>
          <el-input v-model="searchInfo.searchKey" placeholder="搜索原因/考核项" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="openDialog()">+ 新增扣分</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border page-name="deductionList">
          <yq-table-column label="日期" prop="deductionDate" min-width="120rem">
            <template v-slot="{row}">{{ dateOnly(row.deductionDate) }}</template>
          </yq-table-column>
          <yq-table-column label="员工" prop="employeeName" min-width="120rem">
            <template v-slot="{row}"><strong>{{ row.employeeName || '—' }}</strong></template>
          </yq-table-column>
          <yq-table-column label="考核项" prop="itemName" min-width="180rem">
            <template v-slot="{row}">{{ row.itemName || '—' }}</template>
          </yq-table-column>
          <yq-table-column label="扣分" prop="points" width="100rem" align="center">
            <template v-slot="{row}"><strong style="color:#f56c6c">-{{ row.points }}</strong></template>
          </yq-table-column>
          <yq-table-column label="原因" prop="reason" min-width="200rem" :show-overflow-tooltip="true">
            <template v-slot="{row}"><span v-if="row.reason">{{ row.reason }}</span><span v-else class="muted">—</span></template>
          </yq-table-column>
          <yq-table-column label="操作" prop="options" align="center" fixed="right" width="110rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button el-type="danger" message="是否确认删除该扣分记录" @click="deleteRow(row.id)">删除</table-button>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 新增扣分弹窗 -->
    <el-dialog v-model="showDialog" title="新增扣分记录" dialog-width="2" :close-on-click-modal="false">
      <form-items :data="dialogData" :columns="2" label-width="2.4rem" icon-width="0" ref="dialogForm">
        <form-item label="员工" :required="true" name="employeeId" error-message="请选择员工">
          <el-select v-model="dialogData.employeeId" placeholder="请选择员工" filterable style="width: 100%" @change="onStaffChange">
            <el-option v-for="e in staffOptions" :key="e.employeeId" :label="staffLabel(e)" :value="e.employeeId"/>
          </el-select>
        </form-item>
        <form-item label="考核项" :required="true" name="itemId" error-message="请选择考核项">
          <el-select v-model="dialogData.itemId" placeholder="按员工KPI类型过滤" filterable style="width: 100%">
            <el-option v-for="it in itemOptions" :key="it.id" :label="it.kpiName + '（上限 ' + it.cap + '）'" :value="it.id"/>
          </el-select>
        </form-item>
        <form-item label="扣分分值" :required="true" name="points" error-message="请输入扣分值">
          <el-input-number v-model="dialogData.points" :min="0.1" :step="1" :precision="1" controls-position="right" style="width: 100%"/>
        </form-item>
        <form-item label="扣分日期" :required="true" name="deductionDate" error-message="请选择扣分日期">
          <el-date-picker v-model="dialogData.deductionDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width: 100%"/>
        </form-item>
        <form-item label="扣分原因" :required="true" name="reason" error-message="请填写扣分原因" :show-block="true">
          <el-input v-model="dialogData.reason" type="textarea" :rows="3" placeholder="简要说明扣分原因"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">登记扣分</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import deductionApi from "@/api/dz-crm/kpi/deductionApi";
import kpiItemApi from "@/api/dz-crm/kpi/kpiItemApi";
import calendarApi from "@/api/dz-crm/kpi/calendarApi";
import commonApi from "@/api/commonApi";

export default {
  setup() {
    return {router: useRouter(), route: useRoute()};
  },
  name: "DeductionList",
  components: {
    FormItems, FormItem, YqTableColumn, TableButton, PageButton,
    SearchCondition, FormPage, ListTable, ListPage
  },
  data() {
    return {
      searchInfo: {pageNumber: 1},
      dataList: [],
      staffOptions: [],
      itemOptions: [],
      kpiTypeDictList: [],
      showDialog: false,
      dialogData: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.initDict();
      this.initStaff();
      this.resetSearch();
    }
  },
  methods: {
    async initDict() {
      const res = await commonApi.queryUniqueDictionaryList("POSITION_ROLE");
      this.kpiTypeDictList = res || [];
    },
    async initStaff() {
      // 平台启用职员（queryEmployeeStaff 返回数组，含外部 employeeId / kpiType / 岗位名）
      const list = await calendarApi.queryEmployeeStaff({});
      this.staffOptions = list || [];
    },
    staffLabel(e) {
      const role = e.roleName ? " · " + e.roleName : "";
      return (e.employeeName || e.employeeId) + role;
    },
    dateOnly(v) {
      return v ? String(v).slice(0, 10) : "—";
    },
    async queryList() {
      const {records, totalCount} = await deductionApi.queryList(this.searchInfo);
      this.dataList = records || [];
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    async onStaffChange(employeeId) {
      const staff = this.staffOptions.find(e => e.employeeId === employeeId);
      this.dialogData.employeeName = staff ? staff.employeeName : "";
      // 职员角色 → KPI类型（POSITION_ROLE 字典 code → 字典项 id）
      this.itemOptions = [];
      this.dialogData.itemId = "";
      if (!staff || !staff.kpiType) {
        this.$message.warning("该职员的角色未设置岗位类型，无法选择考核项");
        return;
      }
      const dictItem = this.kpiTypeDictList.find(t => t.dictCode === staff.kpiType);
      const kpiId = dictItem ? dictItem.id : staff.kpiType;
      // kpiItem.queryList 返回数组（非 PageBean），勿用 {records} 解构
      const list = await kpiItemApi.queryList({kpiPositionId: kpiId});
      this.itemOptions = list || [];
      if (!this.itemOptions.length) {
        this.$message.warning("该 KPI 类型下还没有考核项，请先到考核项设置中添加");
      }
    },
    openDialog() {
      const today = new Date();
      const now = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");
      this.dialogData = {employeeId: "", employeeName: "", itemId: "", points: 1, deductionDate: now, reason: ""};
      this.itemOptions = [];
      this.showDialog = true;
    },
    async saveData() {
      if (!this.$refs.dialogForm.validCheck()) { // 数据验证不通过
        return;
      }
      await deductionApi.save(this.dialogData);
      this.showDialog = false;
      this.resetSearch();
    },
    async deleteRow(id) {
      await deductionApi.delete(id);
      this.resetSearch();
    },
  },
};
</script>

<style lang="scss" scoped>
.deduction-list {
  height: 100%;
}
</style>
